(() => {
  'use strict';
  if (window.ardanShieldProductStateReady) return;
  window.ardanShieldProductStateReady = true;

  function guardPurchase(event) {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const button = target.closest('button, input[type="submit"], .add_to_cart');
    if (event.type === 'click' && (!button || button.type === 'button')) return;
    const form = target.closest('form');
    const acknowledgement = form?.querySelector('[data-compatibility-acknowledgement]');
    if (!acknowledgement || acknowledgement.checked) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    acknowledgement.focus();
    acknowledgement.reportValidity();
  }

  function updateSchema(wrapper) {
    const productSection = wrapper.closest('.product_section');
    const schema = document.querySelector('[data-as-product-schema]');
    if (!schema || !productSection || productSection.classList.contains('js-product-section--quickshop')) return;
    try {
      const product = JSON.parse(wrapper.dataset.product);
      if (String(product.id) !== schema.dataset.productId) return;
      const selectedId = wrapper.querySelector('select[name="id"], input[name="id"]')?.value;
      const variant = product.variants.find(item => String(item.id) === selectedId);
      const entity = JSON.parse(schema.textContent);
      if (!variant) {
        delete entity.offers;
        delete entity.sku;
        delete entity.gtin;
      } else {
        const url = new URL(entity.url);
        url.searchParams.set('variant', variant.id);
        entity.offers = {
          ...(entity.offers || JSON.parse(schema.dataset.initialOffer)),
          url: url.href,
          price: variant.price / 100,
          availability: `https://schema.org/${variant.available ? 'InStock' : 'OutOfStock'}`,
        };
        if (variant.sku) entity.sku = variant.sku;
        else delete entity.sku;
        if (/^(?:\d{8}|\d{12}|\d{13}|\d{14})$/.test(variant.barcode || '')) entity.gtin = variant.barcode;
        else delete entity.gtin;
      }
      schema.textContent = JSON.stringify(entity).replace(/</g, '\\u003c');
    } catch {
      // Keep the server-rendered entity if a third-party script supplies incomplete data.
    }
  }

  function rememberOffers() {
    document.querySelectorAll('[data-as-product-schema]').forEach(schema => {
      if (schema.dataset.initialOffer) return;
      try { schema.dataset.initialOffer = JSON.stringify(JSON.parse(schema.textContent).offers); } catch { /* Invalid app output must not break purchase controls. */ }
    });
  }

  document.addEventListener('click', guardPurchase, true);
  document.addEventListener('submit', guardPurchase, true);
  document.addEventListener('change', event => {
    const wrapper = event.target instanceof Element && event.target.closest('[data-product-form]');
    if (!wrapper) return;
    rememberOffers();
    window.requestAnimationFrame(() => updateSchema(wrapper));
  });
  rememberOffers();
  document.addEventListener('shopify:section:load', rememberOffers);
})();
